export default __webpack_public_path__ + "static/media/regions.5b95a6d9.png";